export function someGetter()
/* state */
{}